import { createSlice, createAsyncThunk, createAction } from "@reduxjs/toolkit";
import HotelService from "./laxuryHotelService";


export const getHotels = createAsyncThunk("Hotel/get-Hotels", async (token,thunkAPI) => {
  try {
    return await HotelService.getHotels(token);
  } catch (error) {
    return thunkAPI.rejectWithValue(error);
  }
}); 
export const createHotel = createAsyncThunk(
  "Hotel/create-Hotels",
  async (AssociationData, thunkAPI) => {
    try {
      return await HotelService.createHotel(AssociationData);
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response.data);
    }
  }
);

export const getHotel = createAsyncThunk(
  "Hotel/get-Hotel",
  async (id, thunkAPI) => {
    try {
      return await HotelService.getHotel(id);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);
export const updateHotel = createAsyncThunk(
  "Hotel/update-Hotel",
  async (id, thunkAPI) => {
    try {
      return await HotelService.updateHotel(id);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const deleteHotel = createAsyncThunk(
  "Hotel/delete-Hotel",
  async (id, thunkAPI) => {
    try {
      return await HotelService.deleteHotel(id);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);
export const resetState = createAction("Reset_all");

const initialState = {
  Hotels: [],
  isError: false,
  isLoading: false,
  isSuccess: false,
  message: "",
};
export const AssociationSlice = createSlice({
  name: "Hotel",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getHotels.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getHotels.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.isSuccess = true;
        state.Hotels = action.payload.data;
      })
      .addCase(getHotels.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        state.message = action.error;
      })
      .addCase(createHotel.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(createHotel.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.isSuccess = true;
        state.createdHotel = action.payload;
      })
      .addCase(createHotel.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        state.message = action.payload;
      })
      .addCase(getHotel.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getHotel.fulfilled, (state, action) => {
        state.isLoading = false; 
        state.isError = false;
        state.isSuccess = true;
        state.hotelname= action.payload.data.name;
        state.hoteltitle= action.payload.data.title;
        state.hoteladdress= action.payload.data.address;
        state.hotelcity= action.payload.data.city;
        state.hotelaccess= action.payload.data.access;
        state.hotelamenities= action.payload.data.amenities;
        state.hotelwebsite= action.payload.data.website;
        state.hotelcountry= action.payload.data.country;
        // state.hotelvideo= action.payload.data.video;
        state.hotelinformation= action.payload.data.information;

      })
      .addCase(getHotel.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        state.message = action.error;
      })
      .addCase(updateHotel.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(updateHotel.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.isSuccess = true;
        state.updatedHotel = action.payload;
      })
      .addCase(updateHotel.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        state.message = action.error;
      })
      .addCase(deleteHotel.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(deleteHotel.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.isSuccess = true;
        state.deletedHotel = action.payload;
      })
      .addCase(deleteHotel.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        state.message = action.error;
      })
      .addCase(resetState, () => initialState);
  },
});
export default AssociationSlice.reducer;
